import React, {useContext} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import Paper from "@mui/material/Paper";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import BarChartIcon from '@mui/icons-material/BarChart';
import ViewListIcon from '@mui/icons-material/ViewList';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import {Locker} from "../utils/Locker";

import css from '../css/navigator.module.css';
import {AppContext} from "./Loading";
import {MiniAppContext} from "../pages/MiniApp";

export const Navigator = ({paths, height}) => {
    const {locked, started} = useContext(MiniAppContext)
    const navigate = useNavigate();
    const location = useLocation();
    const index = paths.findIndex(p => location.pathname.includes(p));

    if (!started) return false;

    return  (
        <div className={css.navigator}>
            <Paper className={css.fixed} elevation={3} style={{height}}>
                <BottomNavigation showLabels value={index} onChange={(e, v) => navigate(paths[v])}>
                    <BottomNavigationAction id={"pageProblems"} label="Задачи" icon={<ViewListIcon/>}/>
                    {locked ? (
                        <Locker top={15} left={37}>
                            <BottomNavigationAction id={"pageStatistics"} label="Статистика" icon={<BarChartIcon/>}/>
                        </Locker>
                    ) : (
                        <BottomNavigationAction id={"pageStatistics"} label="Статистика" icon={<BarChartIcon/>}/>
                    )}
                    <BottomNavigationAction id={"pageProfile"} label="Профиль" icon={<AccountBoxIcon/>}/>
                </BottomNavigation>
            </Paper>
        </div>
    )
}
